var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPickup = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9.059,
    height: 10.28,
    viewBox: "0 0 9.059 10.28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#e2556d;stroke:#e2556d;stroke-width:.2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "source-location",
    transform: "translate(-30.9 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6781",
    transform: "translate(31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8644",
    d: "M37.113 6.66c1.073-1.683.938-1.473.969-1.517a3.224 3.224 0 0 0 .6-1.875 3.248 3.248 0 1 0-5.883 1.9l.952 1.493C32.729 6.816 31 7.282 31 8.308c0 .374.244.907 1.407 1.322a9.321 9.321 0 0 0 3.023.45c2.127 0 4.43-.6 4.43-1.772-.001-1.026-1.728-1.491-2.747-1.648zm-3.824-1.818l-.01-.015A2.658 2.658 0 1 1 37.6 4.8c-.028.038.12-.193-2.173 3.4zm2.141 4.647c-2.323 0-3.839-.683-3.839-1.181 0-.335.779-.886 2.505-1.1l1.085 1.7a.3.3 0 0 0 .5 0l1.085-1.7c1.726.215 2.505.766 2.505 1.1-.002.492-1.505 1.181-3.841 1.181z",
    className: "cls-1",
    transform: "translate(-31)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6783",
    transform: "translate(33.953 1.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8645",
    d: "M182.477 91a1.477 1.477 0 1 0 1.477 1.477A1.478 1.478 0 0 0 182.477 91zm0 2.363a.886.886 0 1 1 .886-.886.887.887 0 0 1-.886.886z",
    className: "cls-1",
    transform: "translate(-181 -91)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPickup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pickup.1f02d068.svg";
export { ForwardRef as ReactComponent };